export default __webpack_public_path__ + "32cb173faf9e23add3ef1e486e604e98.png";